import JobAdvertCard from './JobAdvertCard';
import styles from '../styles/jobAdvertGrid.module.scss';
import Box from '@mui/material/Box';
export default function JobAdvertGrid({ adverts }) {

    if (!adverts || adverts.length === 0) {
        return (
            <p className={styles.noResults}>
                There are currently no vacancies available.
            </p>
        );
    }

    return (

        <div className={styles.grid}>

                {adverts.map(advert => (
                    <JobAdvertCard
                        key={advert.id}
                        advert={advert}
                    />
                ))}
            

        </div>

    );

}